module.exports = __webpack_public_path__ + "static/media/S1-34-Trowerbell-cod65.cda77620.png";